import { render, staticRenderFns } from "./StickyMobileAddToCart.vue?vue&type=template&id=540bfe2a&scoped=true&"
import script from "./StickyMobileAddToCart.vue?vue&type=script&lang=js&"
export * from "./StickyMobileAddToCart.vue?vue&type=script&lang=js&"
import style0 from "./StickyMobileAddToCart.vue?vue&type=style&index=0&id=540bfe2a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540bfe2a",
  null
  
)

export default component.exports